// TODO: adapt hosts
const v1Host = 'https://checkin.civitfun.com';
const v2Host = 'https://checkin-beta.civitfun.com';

function handlePaperlessVersionWithAutologin({ paperlessVersion, token }) {
  const currentDomain = window.location.origin;
  console.log('handlePaperlessVersionWithAutologin', { currentDomain, paperlessVersion });
  if (paperlessVersion === 'v2' && currentDomain === v1Host) {
    window.location.href = `${v2Host}/login?autoLogin=true&token=${token}`;
    return true;
  } else if (paperlessVersion === 'v1' && currentDomain === v2Host) {
    window.location.href = `${v1Host}/login?autoLogin=true&token=${token}`;
    return true;
  }
}

function handlePaperlessVersion() {
  const paperlessVersion = localStorage.getItem('paperless-version') || null;
  const currentDomain = window.location.origin;
  console.log('handlePaperlessVersion', { currentDomain, paperlessVersion });
  if (paperlessVersion === 'v2' && currentDomain === v1Host) {
    window.location.href = `${v2Host}/?isKiosk=true`;
    return;
  } else if (paperlessVersion === 'v1' && currentDomain === v2Host) {
    window.location.href = `${v1Host}/?isKiosk=true`;
    return;
  }
}

export { handlePaperlessVersionWithAutologin, handlePaperlessVersion };
